const recommendationTypes = {
    pracuj: 'Na Pracuj.pl',
    theprotocol: 'Na the:protocol'
};

export default recommendationTypes;